// extracted by mini-css-extract-plugin
module.exports = {"popup":"c6e8ba5398--popup--3xzr3","close":"c6e8ba5398--close--1eTh-","raise_bet_link":"c6e8ba5398--raise_bet_link--3YsFV"};